const validatePage5 = (values) => {
    const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

    const errors = {}
    if (!values.correoElectrónico) {
        errors.correoElectrónico = 'Este campo es requerido, indique su correo electrónico'
    }
    if (!regexEmail.test(values.correoElectrónico)) {
        errors.correoElectrónico = 'El correo electrónico digitado no es valido.'
    }
    if (!values.numeroCelular) {
        errors.numeroCelular = 'Este campo es requerido, indique su número de celular'
    }
    if (values.numeroCelular) {
        if (values?.numeroCelular?.length !== 10) {
            errors.numeroCelular = 'El número de celular debe de tener 10 dígitos.'
        }
    }
    if(values.teléfono){
        if (values?.teléfono?.length !== 7) {
            errors.teléfono = 'El número de telefono debe de tener 7 dígitos.'
        }
    }

    if(values.teléfonoFamiliar){
        if (values?.teléfonoFamiliar?.length !== 7 && values?.teléfonoFamiliar?.length !== 10 ) {
            errors.teléfonoFamiliar = 'El número de teléfono del allegado puede tener solo 7 dígitos si es un número fijo o 10 dígitos si es un número celular.'
        }
    }
    return errors
}

export default validatePage5;